<template>
  <div class="page-container">
    <el-card class="page-content" shadow="never">
      <div
        class="page-actions"
        style="display: flex; justify-content: space-between"
      >
        <div class="select">
          <div class="item">
            <div class="ipt">
              <el-input
                placeholder="搜索交易员名称"
                clearable
                v-model="id"
                size="mini"
              >
              </el-input>
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-input
                placeholder="搜索用户UID"
                clearable
                v-model="id"
                size="mini"
              >
              </el-input>
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-select
                v-model="symbolId"
                placeholder="交易员选择"
                clearable
                size="mini"
              >
                <el-option
                  v-for="item in payerArr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-select
                v-model="symbolId"
                placeholder="选择状态"
                clearable
                size="mini"
              >
                <el-option
                  v-for="item in typeArr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-select
                v-model="symbolId"
                placeholder="是否开启"
                clearable
                size="mini"
              >
                <el-option
                  v-for="item in isEnAbleArr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-switch
                v-model="leverSwitch"
                active-text="待升级"
                inactive-text="关"
              >
              </el-switch>
            </div>
          </div>

          <div class="item">
            <el-button
              size="mini"
              type="primary"
              @click="handleSearch({ page: 1 })"
              >查询</el-button
            >
          </div>
        </div>
      </div>
      <el-table :data="tabList" height="900">
        <el-table-column label="头像" prop="symbol" />
        <el-table-column label="交易员名称" prop="takerFee" />
        <el-table-column label="用户UID" prop="takerFee" />
        <el-table-column prop="" label="交易员等级">
          <template slot-scope="scope">
            <span>钻石交易员(12%)</span>
          </template>
        </el-table-column>
        <el-table-column prop="" label="当前跟单/最大跟单">
          <template slot-scope="scope">
            <span class="buleTxt" @click="showTabBox('showCopyerModal')"
              >123</span
            >
            <span>/{{ 200 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="" label="累计跟随人数" />
        <el-table-column prop="" label="总胜率">
          <template slot-scope="scope">
            <span>66.66%</span>
          </template>
        </el-table-column>
        <el-table-column label="总收益" prop="takerFee" />
        <el-table-column label="总分润" prop="takerFee" />
        <el-table-column label="总权益(USDT)" prop="takerFee" />
        <el-table-column label="盈利笔数/跟单笔数" prop="takerFee" />
        <el-table-column prop="" label="申请状态">
          <template slot-scope="scope">
            <el-tag>标签一</el-tag>
            <el-tag type="success">标签二</el-tag>
            <el-tag type="info">标签三</el-tag>
            <el-tag type="warning">标签四</el-tag>
            <el-tag type="danger">标签五</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="" label="开启状态">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.leverSwitch"
              @change="handleUpdateMarkStatus(scope.row.id, $event, 'mark')"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" width="160">
          <template slot-scope="scope">
            <span>{{ scope.row.createdTime | moment }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作员" prop="symbol" />
        <el-table-column label="操作" fixed="right" width="120">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="show(scope.row)"
              >分析</el-button
            >
            <el-button type="text" size="mini" @click="downLevel(scope.row)"
              >降级</el-button
            >
            <el-button type="text" size="mini" @click="audit(scope.row)"
              >审核</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :size="pagination.size"
        :total="totalCount"
        :page="pagination.page"
        @pageChanged="paginationHandle"
      >
      </pagination>

      <el-dialog
        :title="tabModaltitle"
        :visible="dialogVisible1"
        width="800px"
        @close="closeTabBox"
        :destroy-on-close="true"
      >
        <div class="modalSearch">
          <el-input placeholder="搜索XT-UID" clearable v-model="id" size="mini">
          </el-input>
          <el-input
            placeholder="搜索合约UID"
            clearable
            v-model="id"
            size="mini"
          >
          </el-input>
          <el-select
            v-model="symbolId"
            placeholder="状态"
            clearable
            size="mini"
          >
            <el-option
              v-for="item in statusArr"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-button
            size="mini"
            type="primary"
            @click="getModalData({ page: 1 })"
            >查询</el-button
          >
        </div>
        <el-table :data="modalTabList">
          <el-table-column label="XT-UID" prop="symbol" />
          <el-table-column label="合约UID" prop="takerFee" />
          <el-table-column prop="" label="状态">
            <template slot-scope="scope"> </template>
          </el-table-column>
          <el-table-column prop="" label="账户权益" />
          <el-table-column label="跟单总交易额" prop="takerFee" />
          <el-table-column label="跟单总盈亏" prop="takerFee" />
          <el-table-column label="更新时间" width="160">
            <template slot-scope="scope">
              <span>{{ scope.row.createdTime | moment }}</span>
            </template>
          </el-table-column>
        </el-table>
        <pagination
          :size="modalPagination.size"
          :total="modalTotalCount"
          :page="modalPagination.page"
          @pageChanged="modalPaginationHandle"
        >
        </pagination>
      </el-dialog>

      <el-dialog
        :title="title"
        :visible="dialogVisible"
        width="800px"
        @close="close"
        :destroy-on-close="true"
      >
        <div class="info">
          <el-descriptions class="margin-top" :column="2">
            <el-descriptions-item label="注册时间">{{
              12312312312 | moment
            }}</el-descriptions-item>
            <el-descriptions-item label="开通跟单时间">{{
              12312312312 | moment
            }}</el-descriptions-item>
            <el-descriptions-item label="用户姓名">苏州市</el-descriptions-item>
            <el-descriptions-item label="KYC类型"> </el-descriptions-item>
            <el-descriptions-item label="合约总权益"
              >江苏省苏州市</el-descriptions-item
            >
            <el-descriptions-item label="累计跟随人数"
              >江苏省苏州市</el-descriptions-item
            >
            <el-descriptions-item label="累计跟单交易额"
              >江苏省苏州市</el-descriptions-item
            >
            <el-descriptions-item label="盈利笔数/带单笔数"
              >江苏省苏州市</el-descriptions-item
            >
            <el-descriptions-item label="累计分润" :span="2"
              >江苏省苏州市(已分润数据)</el-descriptions-item
            >
            <el-descriptions-item label="交易员等级" :span="2"
              >明星交易员(10%)<span>设置</span>
            </el-descriptions-item>
          </el-descriptions>

          <el-tabs v-model="activeTab" @tab-click="handleTabChange">
            <el-tab-pane label="当前带单" name="aa"></el-tab-pane>
            <el-tab-pane label="历史带单" name="bb"></el-tab-pane>
            <el-tab-pane label="行为日志" name="cc"></el-tab-pane>
            <el-tab-pane label="风控日志" name="dd"></el-tab-pane>
          </el-tabs>
          <el-table :data="modalTabList">
            <template v-if="activeTab == 'aa'">
              <el-table-column label="带单合约" width="160">
                <template slot-scope="scope">
                  <span>BTC_USDT</span>
                  <span>永续</span>
                </template>
              </el-table-column>
              <el-table-column label="开仓价" prop="takerFee" />
              <el-table-column label="最新价" prop="takerFee" />
              <el-table-column label="开仓时间" width="160">
                <template slot-scope="scope">
                  <span>{{ scope.row.createdTime | moment }}</span>
                </template>
              </el-table-column>
              <el-table-column label="开仓数量" prop="takerFee" />
              <el-table-column prop="" label="未实现盈亏">
                <template slot-scope="scope">
                  <span class="redTxt">{{}}</span>
                  <span class="greenTxt">{{}}</span>
                </template>
              </el-table-column>
              <el-table-column label="跟单人数" prop="takerFee" />
              <el-table-column label="跟单总量" prop="takerFee" />
            </template>
            <template v-if="activeTab == 'bb'">
              <el-table-column label="带单合约" width="160">
                <template slot-scope="scope">
                  <el-tag>标签一</el-tag>
                  <span>BTC_USDT</span>
                </template>
              </el-table-column>
              <el-table-column label="开仓价" prop="takerFee" />
              <el-table-column label="平仓价" prop="takerFee" />
              <el-table-column label="开仓时间" width="160">
                <template slot-scope="scope">
                  <span>{{ scope.row.createdTime | moment }}</span>
                </template>
              </el-table-column>
              <el-table-column label="平仓时间" width="160">
                <template slot-scope="scope">
                  <span>{{ scope.row.createdTime | moment }}</span>
                </template>
              </el-table-column>
              <el-table-column label="平仓数量" prop="takerFee" />
              <el-table-column prop="" label="平仓盈亏">
                <template slot-scope="scope">
                  <span class="redTxt">{{}}</span>
                  <span class="greenTxt">{{}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="" label="带单利润">
                <template slot-scope="scope">
                  <span class="redTxt">{{}}</span>
                  <span class="greenTxt">{{}}</span>
                </template>
              </el-table-column>
              <el-table-column label="跟单人数" prop="takerFee" />
              <el-table-column label="跟单总量" prop="takerFee" />
            </template>

            <template v-if="activeTab == 'cc'">
              <el-table-column label="日志类型">
                <template slot-scope="scope">
                  <span>sadasd</span>
                </template>
              </el-table-column>
              <el-table-column label="操作时间">
                <template slot-scope="scope">
                  <span>{{ scope.row.createdTime | moment }}</span>
                </template>
              </el-table-column>
            </template>

            <template v-if="activeTab == 'dd'">
              <el-table-column label="日志类型">
                <template slot-scope="scope">
                  <span>sadasd</span>
                </template>
              </el-table-column>
              <el-table-column label="操作时间">
                <template slot-scope="scope">
                  <span>{{ scope.row.createdTime | moment }}</span>
                </template>
              </el-table-column>
            </template>
          </el-table>
          <pagination
            :size="modalPagination.size"
            :total="modalTotalCount"
            :page="modalPagination.page"
            @pageChanged="modalPaginationHandle"
          >
          </pagination>
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import Pagination from "components/pagination";
import api from "./api";

export default {
  components: {
    Pagination,
  },
  data() {
    return {
      id: "",
      symbolId: "",
      symbolList: [],
      tabList: [],
      totalCount: 0,
      pagination: {
        page: 1,
        size: 25,
      },
      modalTabList: [],
      modalTotalCount: 0,
      modalPagination: {
        page: 1,
        size: 25,
      },
      leverSwitch: false,
      dialogVisible: false,
      title: "",
      dialogVisible1: false,
      tabModaltitle: "xx的列表",
      formData: {
        tabData: [],
        title: "",
        info: {},
      },
      statusArr: [
        { label: "全部", value: "" },
        { label: "跟单中", value: "1" },
        { label: "已取消", value: "2" },
      ],
      typeArr: [
        { label: "全部状态", value: "" },
        { label: "申请交易员待审核", value: "1" },
        { label: "取消交易员待审核", value: "2" },
        { label: "申请交易员通过", value: "1" },
        { label: "申请交易员拒绝", value: "1" },
        { label: "取消交易员通过", value: "1" },
        { label: "取消交易员拒绝", value: "1" },
      ],
      payerArr: [
        { label: "全部交易员", value: "" },
        { label: "初级交易员", value: "1" },
        { label: "明星交易员", value: "2" },
        { label: "钻石交易员", value: "2" },
      ],
      isEnAbleArr: [
        { label: "已开启", value: "" },
        { label: "已隐藏", value: "1" },
      ],
      activeTab: "aa",
    };
  },
  computed: {},
  mounted() {
    api.getSymbolList({ type: "CONTRACT" }).then((res) => {
      if (res.code == 0) {
        this.symbolList = res.data;
      }
    });
    this.handleSearch();
  },
  methods: {
    handleSearch(data = {}) {
      api
        .getSpotSymbolPage({
          id: this.id,
          symbolId: this.symbolId,
          ...this.pagination,
          ...data,
        })
        .then((res) => {
          if (res.code == 0) {
            const { totalCount, list } = res.data;
            this.tabList = list;
            this.totalCount = totalCount;
          }
        });
    },
    paginationHandle(pagination) {
      this.pagination = pagination;
      this.handleSearch();
    },
    show(row) {
      // if (row) {
      //   this.formData = JSON.parse(JSON.stringify(row));
      //   this.formData.createdTime = undefined;
      //   this.formData.updatedTime = undefined;
      // }
      this.formData = { tabData: [], title: "", info: {} };
      this.dialogVisible = true;
    },
    close() {
      this.dialogVisible = false;
      this.formData = { tabData: [], title: "", info: {} };
    },
    handleSave() {
      if (this.formData.id == "") {
        return this.$message.error("请选择交易对ID");
      }
      api.updateSpotSymbol(this.formData).then((res) => {
        if (res.code == 0) {
          this.$message.success("成功");
          this.close();
          this.handleSearch();
        }
      });
    },

    showTabBox(type) {
      this.dialogVisible1 = true;
      // this.tabModaltitle=''
      this.getModalData();
    },
    getModalData(data = {}) {
      this.handleSearch();
    },
    closeTabBox() {
      this.dialogVisible1 = false;
      this.tabModaltitle = "";
      this.modalTabList = [];
      this.modalTotalCount = 0;
      this.modalPagination = {
        page: 1,
        size: 25,
      };
    },
    modalPaginationHandle(pagination) {
      this.modalPagination = pagination;
      this.getModalData();
    },
    handleTabChange(tab) {
      this.modalTabList = [];
      this.modalTotalCount = 0;
      this.modalPagination = {
        page: 1,
        size: 25,
      };
      this.getCopyModalTabData();
    },
    getCopyModalTabData() {
      console.log("2222", 2222);
      // ...modalPagination
    },
    handleUpdateMarkStatus(userId, value, type) {
      this.$confirm("确认进行该操作吗？", "提示", {
        type: "warning",
      }).then(() => {
        api[type]({ userId, [type]: value }).then((res) => {
          if (res.code == 0) {
            this.$message.success("操作成功！");
            this.$emit("refresh");
          }
        });
      });
    },
    downLevel(row) {
      this.$confirm("你确定将交易员降为最低等级？", "提示", {
        type: "warning",
      }).then(() => {
        console.log("22222222", 22222222);
        // api[type]({ userId, [type]: value }).then((res) => {
        //   if (res.code == 0) {
        //     this.$message.success("操作成功！");
        //     this.$emit("refresh");
        //   }
        // });
      });
    },
    audit(row) {
      this.$prompt("请输入邮箱", "申请交易员待审核’/‘取消交易员待审核’？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern:
          /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
        inputErrorMessage: "邮箱格式不正确",
      })
        .then(({ value }) => {
          this.$message({
            type: "success",
            message: "你的邮箱是: " + value,
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },
  },
};
</script>

<style lang="less" src="../../styles/button.less" scoped></style>
<style scoped lang="less">
.buleTxt {
  color: blue;
  cursor: pointer;
  user-select: none;
}
.modalSearch {
  display: flex;
  gap: 20px;
  .el-input {
    width: 200px;
  }
}
.greenTxt {
  color: #409eff;
}
.redTxt {
  color: red;
}
</style>
